<template>
  <el-container class="share-wrapper" v-loading="isShowLoading">
    <el-header height="66px">
      <img src="@/assets/images/logo.png" class="logo">
      <span class="header-title">
        {{ currentItem.workOrderNo }}（基因名称：{{ currentItem.workOrderName }}） /
        <span class="title-name">{{ currentItem.fragmentName }}</span>
      </span>
      <el-button type="primary" @click="downloadImage">
        基因合成生产进度关系图谱
        <i class="el-icon-download el-icon--right" />
      </el-button>
    </el-header>
    <el-container>
      <el-aside width="200px" class="side-menu">
        <div class="title">订单生产进度列表</div>
        <el-menu :default-active="defaultActiveId">
          <el-submenu v-for="item in workOrderList" :key="item.workOrderId" :index="item.workOrderId.toString()">
            <span slot="title">{{ item.workOrderNo }}</span>
            <el-menu-item v-for="subItem in item.geneFragmentDesigns" :key="subItem.id" :index="subItem.id.toString()"
              @click="changeMenuItem(item, subItem)">{{subItem.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <el-button type="primary" icon="el-icon-arrow-left" plain class="switch-item-btn"
          @click="changeChartHandler('left')" />
        <div ref="sankeyChartRef" class="my-chart" />
        <el-button type="primary" icon="el-icon-arrow-right" plain class="switch-item-btn"
          @click="changeChartHandler('right')" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import * as echarts from 'echarts'
import moment from 'moment'
import lodash from 'lodash'
import { fetchGeneWorkOrderList, fetchGeneFragmentDetail } from '@/services/api.index'
export default {
  name: 'GeneGraph',
  data() {
    return {
      myChart: null,
      isShowLoading: false,
      defaultActiveId: '',
      workOrderList: [],
      currentItem: {},
      sankeyData: {
        data: [],
        links: []
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    initCharts() {
      const myChart = echarts.init(this.$refs.sankeyChartRef)
      const isSmall = this.sankeyData.links.length < 4
      let chartSize = {}
      if (isSmall) {
        chartSize = {
          height: '15%',
          right: '30%',
          left: '20%',
          top: '40%'
        }
      }else {
        chartSize = {
          height: '100%',
          right: '20%',
          left: '3%',
          top: 0
        }
      }
      this.myChart = myChart
      myChart.setOption({
        series: {
          type: 'sankey',
          draggable: false,
          ...chartSize,
          emphasis: {
            focus: 'adjacency'
          },
          lineStyle: {
            curveness: 0.8,
            color: 'source'
          },
          itemStyle: {
            color: '#1f77b4'
          },
          label: {
            color: 'rgba(0,0,0,0.7)',
            fontFamily: 'Arial',
            fontSize: 14
          },
          data: this.sankeyData.data,
          links: this.sankeyData.links
        }
      })
    },
    changeMenuItem({ workOrderNo, workOrderName, workOrderId }, { id, name }) {
      this.currentItem = {
        workOrderNo,
        workOrderName,
        fragmentName: name
      }
      this.defaultActiveId = id.toString()
      this.getChartData(workOrderId, id)
    },
    async getList() {
      const { query } = this.$route
      // 后端接口两种方式传参，兼容处理
      if (query.workOrderIds) {
        query.workOrderIds = query.workOrderIds.split(',')
      }
      const { data } = await fetchGeneWorkOrderList(query)
      this.workOrderList = data
      this.changeMenuItem(data[0], data[0].geneFragmentDesigns[0])
    },
    async getChartData(workOrderId, designId) {
      this.isShowLoading = true
      const { data } = await fetchGeneFragmentDetail({
        workOrderId,
        designId
      })
      const { sankeyData, sankeyLinks } = data.reduce(
        (acc, item) => {
          if (item.kids.length) {
            this.processItem(item, null, acc)
          }
          return acc
        },
        { sankeyData: [], sankeyLinks: [] }
      )
      this.sankeyData.links = sankeyLinks
      this.sankeyData.data = lodash.uniqBy(sankeyData, 'name')
      this.initCharts()
      this.isShowLoading = false
    },
    //递归树状结构
    processItem(item, parentName, acc) {
      const itemName = this.getItemName(item)
      const itemColor = this.randomHexColor()
      const subItemsData = []
      const subLinksData = []

      if (item.kids.length) {
        item.kids
          .filter(({ name, workOrderStatus }) => name && workOrderStatus !== 'CLOSE')
          .forEach(subItem => {
            const subItemName = this.getItemName(subItem)
            const subItemColor = this.randomHexColor()

            subItemsData.push({ name: subItemName, itemStyle: { color: subItemColor } })
            subLinksData.push({ target: itemName, source: subItemName, value: item.sequenceLength })

            // Recursively process subitems
            this.processItem(subItem, itemName, acc)
          })
      }

      // Add current item to sankeyData
      acc.sankeyData.push({ name: itemName, itemStyle: { color: itemColor } })
      acc.sankeyLinks.push(...subLinksData)

      // Add subitems data to sankeyData
      acc.sankeyData.push(...subItemsData)
    },
    downloadImage() {
      const link = document.createElement('a')
      link.download = this.currentItem.fragmentName
      link.style.display = 'none'
      link.href = this.myChart.getDataURL({
        type: 'png',
        pixelRatio: 1,
        backgroundColor: '#fff'
      }) // 导出图表图片，返回一个 base64 的 URL
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.href) //释放URL对象
      document.body.removeChild(link)
    },
    getItemName({ name, estimatedDate, id, workOrderStatusName, workOrderStatus }) {
      if(!name) {
        return `id: ${id}`
      }
      const date = estimatedDate ? moment(estimatedDate).format('YYYY-MM-DD') : ''
      if (['WAIT', 'ING'].includes(workOrderStatus) && date) {
        return `${name}_${id}\n（状态：${workOrderStatusName}；预计完成时间：${date}）`
      }
      return `${name}_${id}\n（状态：${workOrderStatusName}）`
    },
    randomHexColor() {
      //随机生成十六进制颜色
      let hex = Math.floor(Math.random() * 16777216).toString(16) //生成ffffff以内16进制数
      while (hex.length < 6) {
        //while循环判断hex位数，少于6位前面加0凑够6位
        hex = '0' + hex
      }
      return '#' + hex //返回‘#'开头16进制颜色
    },
    changeChartHandler(direction) {
      // 边界检查
      if (this.workOrderList.length === 1 && this.workOrderList[0].geneFragmentDesigns.length === 1) {
        return this.$message.error('当前只有一份关系图谱')
      }

      let fragmentIndex = -1
      const arrIndex = this.workOrderList.findIndex(({ geneFragmentDesigns }) => {
        fragmentIndex = geneFragmentDesigns.findIndex(({ id }) => id == this.defaultActiveId)
        return fragmentIndex !== -1
      })

      let nextArrIndex = arrIndex
      let nextFragmentIndex = fragmentIndex + (direction === 'left' ? -1 : 1)

      //第一个订单结尾跳到下一订单第一个（right）
      if (nextFragmentIndex === this.workOrderList[arrIndex].geneFragmentDesigns.length) {
        nextArrIndex = (arrIndex + 1) % this.workOrderList.length //循环至开头
        nextFragmentIndex = 0
      }

      // 跳到上一个订单最后一个（left）
      if (nextFragmentIndex === -1) {
        nextArrIndex = (arrIndex - 1 + this.workOrderList.length) % this.workOrderList.length //循环至结尾
        nextFragmentIndex = this.workOrderList[nextArrIndex].geneFragmentDesigns.length - 1
      }

      this.changeMenuItem(
        this.workOrderList[nextArrIndex],
        this.workOrderList[nextArrIndex].geneFragmentDesigns[nextFragmentIndex]
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.share-wrapper {
  height: 100vh;
  background: #fff;
  .el-header {
    padding: 0 50px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 125px;
    }
    .header-title {
      font-size: 16px;
      .title-name {
        color: #13489d;
        font-weight: bold;
      }
    }
    .el-icon-download {
      font-size: 18px;
    }
  }
  .el-container {
    padding: 14px 50px;
    align-items: flex-start;
    .side-menu {
      overflow-x: hidden;
      overflow-y: auto;
      background: #f9f9f9;
      height: calc(100vh - 66px - 28px);
      width: 210px;
      margin-right: 40px;
      .title {
        margin: 15px 20px 0;
        padding-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid #e4e6ea;
      }
      .el-menu {
        background: #f9f9f9;
        border-right: 0;
      }
      .el-menu-item.is-active {
        font-weight: bold;
        background: none;
      }
    }
    .el-main {
      height: 100%;
      position: relative;
      .my-chart {
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
      }
      .switch-item-btn {
        border: none;
        position: absolute;
        z-index: 2;
        top: 40%;
        font-size: 16px;
        &:first-child {
          left: 0;
        }
        &:last-child {
          right: 0;
        }
      }
    }
  }
}
section {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/share/gene-graph/index.vue